import request from "@/utils/request";

export default function agentReplaceAccessControlDevice(beforeId, afterId) {
  return request.post(
    `/device/accessDevice/agent/replaceAccessControlDevice/${beforeId}/${afterId}`
  );
}
